import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import QuestionContainer from './QuestionContainer';

const Q15 = ({ history }) => {
  const { t } = useTranslation();
  const Q15Options = useMemo(
    () => [
      {
        id: 0,
        name: t('yes'),
        value: 'yes',
      },
      {
        id: 1,
        name: t('no'),
        value: 'no',
      },
      {
        id: 2,
        name: t('not_sure'),
        value: 'not_sure',
      },
    ],
    [t]
  );

  return (
    <QuestionContainer
      history={history}
      title={t('question15')}
      options={Q15Options}
      nextUrl="q16"
      screenName="q15"
    />
  );
};

export default Q15;
